module.exports = __webpack_public_path__ + "static/media/user-edit.a190d0e1.svg";